import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styles: [
    `
    img{
      width: 100%;
    }
    `
  ]
})
export class ContactoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
